import styled from "styled-components";

const TableRow = styled.tr`
  opacity: ${props => props.localLoader && "0.1"};
  cursor: ${props => (props.localLoader ? "not-allowed" : "auto")};
`;

export default TableRow;
